import { render, staticRenderFns } from "./searchTop.vue?vue&type=template&id=3016c1ae&scoped=true"
import script from "./searchTop.vue?vue&type=script&lang=js"
export * from "./searchTop.vue?vue&type=script&lang=js"
import style0 from "./searchTop.vue?vue&type=style&index=0&id=3016c1ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3016c1ae",
  null
  
)

export default component.exports